export default {
  orders: [],
  allOrders: [],
  selectedOrder: {},
  editOrder: {},
  orderZone: [],
};
